import { createTheme } from "@mui/material";

class BrandThemeProvider {
    readonly textFieldStyleColour = '#36454B';
    readonly errorColour = '#cc2626';

    getTheme() {
        return createTheme({
            palette: {
                primary: {
                    main: '#36454B',
                    contrastText: '#fff',
                },
                // secondary: {
                //     // light: '#55dab3',
                //     main: '#bb8400',
                //     // dark: '#007856',
                //     contrastText: '#000',
                // }
            },
            components: {
                MuiTextField: {
                    styleOverrides: {
                        root: {
                            // "& .MuiOutlinedInput-root": {
                            //     "& .MuiOutlinedInput-notchedOutline": {
                            //         borderColor: this.textFieldStyleColour,
                            //         borderWidth: "2px",
                            //     },
                            //     "&.Mui-focused": {
                            //         "& .MuiOutlinedInput-notchedOutline": {
                            //             borderColor: this.textFieldStyleColour,
                            //             borderWidth: "2px",
                            //         },
                            //     },
                            //     "&:hover:not(.Mui-focused)": {
                            //         "& .MuiOutlinedInput-notchedOutline": {
                            //             borderColor: this.textFieldStyleColour,
                            //         },
                            //     },
                            // },
                            // "& .MuiInputLabel-outlined": {
                            //     color: this.textFieldStyleColour,
                            //     fontWeight: "bold",
                            //     "&.Mui-focused": {
                            //         color: this.textFieldStyleColour,
                            //     },
                            // },
                            "& .MuiInputLabel-root.Mui-error": {
                                color: this.errorColour,
                            },
                            "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                                border: `1.5px solid ${this.errorColour}`,
                            },
                            "& .MuiFormHelperText-root.Mui-error": {
                                color: this.errorColour,
                            },
                        }
                    }
                }
            }
        });
    }
}

export const brandThemeProvider = new BrandThemeProvider();